import { render } from "./Oferta3.vue?vue&type=template&id=d24ea7e6&scoped=true"
import script from "./Oferta3.vue?vue&type=script&lang=js"
export * from "./Oferta3.vue?vue&type=script&lang=js"

import "./Oferta3.vue?vue&type=style&index=0&id=d24ea7e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d24ea7e6"]])

export default __exports__